module.exports = __webpack_public_path__ + "static/media/mcmenu.8c87e5f7.svg";